import axios from "axios";
import { Base64 } from "js-base64";

const API_URL = process.env.REACT_APP_API_SERVER;
const API_URL_CORE = process.env.REACT_APP_CORE_SERVER;

const getParamUrl = () => {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let token = params.get("token");
  if (!token) {
    const tokenPath = window.location.pathname
      .split("/")
      .filter(Boolean)
      ?.pop()
      ?.split(".")
      ?.filter(Boolean)
      ?.pop();

    token = tokenPath;
  }

  return token;
};


const Header = {
  Authorization: `bearer ${getParamUrl()}`,
  "Content-Type": "application/json",
  Accept: "application/json, */*",
};

async function apiCall(method, url, data, headerParam = {}, timeout = 20000) {
  return axios({
    method,
    url: API_URL + url,
    data,
    headers: {
      Authorization: `bearer ${getParamUrl()}`,
      "Content-Type": "application/json; charset=utf-8",
      ...headerParam
    },
    withCredentials: true,
    timeout,
  });
}

async function apiCallCore(method, url, data) {
  var data_base64 = Base64.encode(JSON.stringify(data));

  return axios({
    method: method,
    url: API_URL_CORE + url,
    data: { data_base64 },
    headers: {
      Authorization: `bearer ${getParamUrl()}`,
      "Content-Type": "application/json; charset=utf-8",
    },
    withCredentials: true,
  });
}

async function apiCallCoreFormData(method, url, data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value); 
    } else if (typeof value === "object") {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });

  return axios({
    method,
    url: API_URL_CORE + url,
    data: formData,
    headers: {
      Authorization: `bearer ${getParamUrl()}`,
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
}

async function apiCallFormData(method, url, data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value); 
    } else if (typeof value === "object") {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });

  return axios({
    method,
    url: API_URL + url,
    data: formData,
    headers: {
      Authorization: `bearer ${getParamUrl()}`,
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
}

const api = { apiCall, apiCallCore, apiCallCoreFormData, apiCallFormData };
export default api;
